import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { tradeOrdersQueryOptions } from "@entities/orders/hooks/use-trade-orders";
import { WalletPageConnector } from "@pages/wallet";

import { Route as BuyRoute } from "./buy";
import { Route as ExchangeRoute } from "./exchange";
import { Route as OrderDetailsRoute } from "./orders/$id";
import { Route as SellRoute } from "./sell";
import { Route as TransactionsRoute } from "./transactions";

export const Route = createFileRoute("/_private/wallet")({
  component: RouteComponent,
  loader: async ({ context }) => {
    try {
      await context.queryClient.ensureInfiniteQueryData(
        tradeOrdersQueryOptions({ assets: [], statuses: [], types: [] }),
      );
    } catch {
      // Ошибку транзакций обрабатывает секция «Последние транзакции»
      // (текст + повтор), экран должен остаться доступен.
    }
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const router = useRouter();

  const handleBuy = useCallback(async () => {
    await navigate({
      to: BuyRoute.fullPath,
    });
  }, [navigate]);

  const handleExchange = useCallback(async () => {
    await navigate({
      to: ExchangeRoute.fullPath,
    });
  }, [navigate]);

  const handleSell = useCallback(async () => {
    await navigate({
      to: SellRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToOrderDetails = useCallback(
    async (id: string) => {
      await navigate({
        params: { id },
        to: OrderDetailsRoute.fullPath,
      });
    },
    [navigate],
  );

  const handleGoToOrderList = useCallback(async () => {
    await navigate({
      to: TransactionsRoute.fullPath,
    });
  }, [navigate]);
  const getOrderHref = useCallback(
    (id: string) =>
      router.buildLocation({ params: { id }, to: OrderDetailsRoute.fullPath })
        .href,
    [router],
  );

  return (
    <WalletPageConnector
      getOrderHref={getOrderHref}
      onGoToBuy={handleBuy}
      onGoToExchange={handleExchange}
      onGoToOrderDetails={handleGoToOrderDetails}
      onGoToOrderList={handleGoToOrderList}
      onGoToSell={handleSell}
    />
  );
}
